<template>
    <div>
        <coupons-info
            :plan="user.plan"
            :campaigns="campaigns"
            :coupons="userCoupons"
            :timezone="user.timezone"
            is-coupon-code>
            クーポン
        </coupons-info>
    </div>
</template>

<script>
    import YokumiruHelper from '../../YokumiruHelper'
    import constants from '../../constants'

    export default {
        props: {
            user: {
                type: Object,
                required: true,
            },
            campaigns: {
                type: Array,
                required: true,
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                userCoupons: [],
            }
        },

        created: function () {
            this.userCoupons = this.user.user_coupons
            bus.$on('user-coupon-published', this.fetchUserCoupons)
        },

        beforeDestroy: function () {
            bus.$off('user-coupon-published')
        },

        methods: {
            fetchUserCoupons: function () {
                axios.get(constants.user.me.endpoint.base)
                    .then(({data}) => {
                        this.userCoupons = data.data.user_coupons
                    })
            },
        }
    }
</script>

<style scoped lang="scss">
.vc-contact {
    font-size: 13px;

    a {
        text-decoration: underline;

        &:hover {
            text-decoration: none;
        }
    }
}
</style>
